export enum PlanProgramStatus {
	AVAILABLE = 'ep-available',
	CAPPED = 'ep-capped',
	DEFERRED = 'ep-deferred',
	FUNDED_ONLY = 'ep-funded-only',
	REMOVED = 'ep-removed',
}
